import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import ProductImage from './ProductImage';
import StockBadge from './StockBadge';
import { cur } from '@/lib/currency';

export default function ProductListRow({ product, imageSrc, onQuickAdd }) {
  const navigate = useNavigate();

  return (
    <div
      className="bg-card border border-border rounded-2xl p-3 flex gap-3 cursor-pointer hover:shadow-md hover:border-primary/30 transition-all active:scale-[0.99]"
      onClick={() => navigate(`/products/${product.id}`)}
    >
      <ProductImage src={imageSrc} categ={product.categ_id} size="list" />

      <div className="flex-1 min-w-0">
        {product.default_code && (
          <p className="text-xs text-muted-foreground font-mono leading-none mb-0.5">{product.default_code}</p>
        )}
        <p className="text-sm font-semibold text-foreground leading-snug line-clamp-2">{product.name}</p>
        <div className="flex items-center gap-2 mt-1 flex-wrap">
          <span className="font-bold text-primary text-sm">
            {Number(product.list_price || 0).toLocaleString('ar-EG', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {cur()}
          </span>
          <StockBadge qty={product.qty_available} />
        </div>
      </div>

      <button
        onClick={e => { e.stopPropagation(); onQuickAdd?.(product); }}
        className="w-9 h-9 bg-primary/10 rounded-xl flex items-center justify-center hover:bg-primary/20 transition-colors flex-shrink-0 self-center"
      >
        <Plus className="w-4 h-4 text-primary" />
      </button>
    </div>
  );
}